// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__p4yCE","tooltip":"styles_tooltip__xWrNG","tooltipWrapper":"styles_tooltipWrapper__SJiY3","actionTriggerScreen":"styles_actionTriggerScreen__tkZTw"};